import { Inject, Injectable } from '@angular/core';
import { PcaAddressSearcher } from './pca-address-searcher';
import { AddressSearcherService } from '@df/ui/form/address-searcher.service';
import { IAddressSearcherData, IAddressSearcherOptions } from '@df/ui/form/address-searcher';
import { NPca } from './pca.interfaces';

@Injectable()
export class PcaAddressSearcherService extends AddressSearcherService {
    constructor(@Inject(NPca.OPTIONS) private moduleOptions: NPca.IModuleOptions) {
        super();
    }

    create(addressSearcherData: IAddressSearcherData, options?: IAddressSearcherOptions) {
        return new PcaAddressSearcher(this.moduleOptions, addressSearcherData, options);
    }
}
